module.exports = "../fonts/IBMPlexSans-Regular.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/IBMPlexSans-Regular.ttf
// module id = 589
// module chunks = 0